//global stores
import { utilityMutations } from "../../../../../Core/Global/Store/utility";
import InfoWindowComponent from "../components/google-map/InfoWindowContent.vue";

export const state = {
    mapOptions: {
        disableDefaultUI: true
    },
    loader: undefined,
    map: undefined,
    options: [],
    markers: [],
    infoWindows: [],
    directionsRenderer: {},
    nearMed: false,
    instanceInitialized: false
}

export const getters = {
    getMapOptions: state => {
        return state.mapOptions;
    }
}

export const mutations = {
    ...utilityMutations,
    SET_MAP_OPTIONS_VALUE(state, [variable, value]){
        state.mapOptions[variable] = value;
    }
}

export const actions = {
    initInstance({ rootGetters, state }) {
        state.loader = new google.maps.plugins.loader.Loader({
            apiKey: rootGetters['location/settings/getAllSettings'].GMK,
            version: 'quarterly',
            libraries: ["geometry"]
        })

        state.instanceInitialized = true;
    },
    initMap({ rootGetters, rootState, getters, commit, state, dispatch }){
        let locationIds = rootGetters['location/locationIds'];

        state.loader.loadCallback(e => {
            if(e){
                console.error(e);
            } else {
                state.map = new google.maps.Map(document.getElementById("map"), getters.getMapOptions);
                let bounds = new google.maps.LatLngBounds();
                let prevWindow = false;

                locationIds.forEach(id => {
                    let location = rootState.location.locations[id];
                    // extend bounds to contain this location
                    bounds.extend({
                        lat: parseFloat(location.latitude),
                        lng: parseFloat(location.longitude)
                    });


                    let InfoWindow = Vue.extend(InfoWindowComponent);
                    let instance = new InfoWindow({ propsData: { location: location } })
                    instance.$mount();

                    //create info window foreach location
                    let infoWindow = new google.maps.InfoWindow({
                        content: instance.$el
                    });

                    state.infoWindows.push(infoWindow);

                    //set up markers for each location
                    let marker = new google.maps.Marker({
                        clickable: true,
                        title: location.title,
                        animation: google.maps.Animation.DROP,
                        position: {
                            lat: parseFloat(location.latitude),
                            lng: parseFloat(location.longitude)
                        },
                    });

                    marker.addListener('click', function(){
                        if (prevWindow) prevWindow.close();
                        prevWindow = infoWindow;
                        infoWindow.open(state.map, marker);
                        commit('location/SET', ['sidebarDetails', id], {root: true});
                    });

                    marker.set('id', id);
                    state.markers.push(marker);
                });

                dispatch('fitNewBounds');
            }
        });
    },
    fitNewBounds({rootGetters, dispatch, state}) {
        let bounds      = new google.maps.LatLngBounds();
        let locationIds = rootGetters['location/locationIds']

        dispatch('closeInfoWindows');

        state.markers.forEach(marker => marker.setMap(null)); // Reset all markers

        if (locationIds.length) {
            if (locationIds.length > 1) { // There is more than one result, use bounds to determine map center
                state.markers.forEach(marker => {
                    let markerId = marker.get('id');
                    if (locationIds.includes(markerId)) {
                        marker.setMap(state.map); // add map if in matchingMarkers
                        bounds.extend(marker.getPosition()); // expand the map bounds to fit new marker
                    }
                });

                state.map.fitBounds(bounds, 32);
            } else { // Only one result, use result coords to determine map center
                let marker = state.markers.find(marker => marker.get('id') == locationIds[0]);
                marker.setMap(state.map); // set marker to map
                state.map.setCenter(marker.getPosition()); // center map on marker
                state.map.setZoom(15); // zoom in
            }
        }
    },
    nearMe({state}) {
        navigator.geolocation.getCurrentPosition(function(pos) {
            let yourPos = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            let closestMarker = state.markers.filter(m => m.map).reduce((a,c,i) => {
                let markerPos = new google.maps.LatLng(c.position.lat(), c.position.lng());
                let dist = google.maps.geometry.spherical.computeDistanceBetween(yourPos, markerPos);
                if (!i || dist < a.dist) a = {marker:c,dist:dist}
                return a;
            }, {marker: null, dist: 0})

            let request = {
                destination: new google.maps.LatLng(closestMarker.marker.position.lat(), closestMarker.marker.position.lng()),
                origin: yourPos,
                travelMode: google.maps.TravelMode.DRIVING
            }

            state.directionsRenderer = new google.maps.DirectionsRenderer();
            let service = new google.maps.DirectionsService();

            service.route(
                request,
                function(response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        state.directionsRenderer.setDirections(response);
                        state.directionsRenderer.setMap(state.map);
                        state.nearMed = true;
                    } else {
                        console.error('Directions request failed due to ' + status);
                    }
                }
            );
        });
    },
    resetNearMe({state}) {
        state.directionsRenderer.setMap(null);
        state.nearMed = false;
    },
    closeInfoWindows({state}) {
        state.infoWindows.forEach(infoWindow => infoWindow.close());
    },
    destroyMap({state}) {
        // nuke markers so when leaving the map view and coming back
        // the map isn't reinitializing more markers on top of old ones
        state.markers.splice(0,state.markers.length);
    }
}

export default { namespaced: true, state, getters, mutations, actions };